import React, { useState } from "react";
import {Consts} from "./consts";
import useMmcService from "../../services/MmcService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";

function TestUploadButton() {
  const { t } = useTranslation();
  const [status, setStatus] = useState(null);
  const [pdmOrderId, setPdmOrderId] = useState("");
  const [showPdmOrderDialog, setShowPdmOrderDialog] = useState(false);
  const { login, sendTestPdmPdf, clearError } = useMmcService();

  const handleShowPdmOrderDialog = async () => {
    try {
      setStatus("Sende PDF...");
      const pdfUrl = `${process.env.PUBLIC_URL || ""}/resources/doseadjust-38cfe866-744c-4d20-b84a-e89b0b1c5a20.pdf`
      const pdfResponse = await fetch(pdfUrl);

      if (!pdfResponse.ok) {
        console.error("handleClick, It was not possible to load a PDF file");
        throw new Error("It was not possible to load a PDF file");
      }

      if (!pdfResponse.ok) {
        throw new Error("It was not possible to load a PDF file locally");
      }

      const pdfBlob = await pdfResponse.blob();

      login({name: "healthlord", password: "geheim"}).then((token) => {
        const formData = new FormData();
        formData.append(Consts.FILE, pdfBlob, "doseadjust-38cfe866-744c-4d20-b84a-e89b0b1c5a20.pdf");

        sendTestPdmPdf(`bearer ${token.token}`, formData, pdmOrderId)
          .then(result => {
            if(!result?.id){
              console.error(`sendTestPdmPdf, backend-error: ${result}`);
            }

            setStatus("sending PDF was successful");
            setPdmOrderId("");
            setShowPdmOrderDialog(false);
          });
      });
    } catch (err) {
      console.error("handleClick, error when sending a pdf file", err);
      setStatus("Error when sending a pdf file");
    }
  };

  return (
    <div>
      {showPdmOrderDialog && (
        <div className="feedback-modal">
          <div className="feedback-modal-content">
            <header className="feedback-modal-header">
              <h2>Enter the PDM order ID</h2>
              <FontAwesomeIcon
                icon={faXmark}
                onClick={() => setShowPdmOrderDialog(false)}
              />
            </header>
            <input
              type="text"
              value={pdmOrderId}
              onChange={(e) => setPdmOrderId(e.target.value)}
              style={{ width: "40ch", padding: "8px", borderRadius: "4px" }}
            />
            <div className="feedback-modal-buttons">
              <button onClick={handleShowPdmOrderDialog} className="w3-btn w3-round-xlarge w3-theme-d5">
                Send the PDF file
              </button>
              <button onClick={() => setShowPdmOrderDialog(false)} className="w3-btn w3-round-xlarge w3-theme-d5">
                {t("cancel")}
              </button>
            </div>
          </div>
        </div>
      )}
      <button className="w3-bar-item w3-hover-light-blue w3-theme-l3 app-nav-item fa-test-color"
              onClick={() => setShowPdmOrderDialog(true)}>
        FaTest: Send Test PDM file to MMC
      </button>
      {status && <div>{status}</div>}
    </div>
  );
}

export default TestUploadButton;